import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';

export default class SendStandaloneEmailVerification extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'auth-temp-sendStandaloneEmailVerification',
      payload: {
        email: this._payload.email,
      },
    });
  }

  handleMessage(message) {
    switch(message) {
      case 'signin.email.already.verified':
        this._dispatch({
          type: Actions.CoreActions.UpdateState,
          payload: {
            user: {
              emailVerified: true
            }
          }
        });
        break;
        default:
          return;
    }
  }

  onSuccess(data) {
    this.handleMessage(data.message);
    super.onSuccess(data);
  }

  onError(data) {
    this.handleMessage(data.message);
    super.onError(data);
  }
}